/* ============================================================
   NORTHSHEEP — Zoom ~3:4 images to fit (JS-rendered cards)
   Recently-viewed, compare and AJAX "you may also like" cards are built in
   JS with no aspect ratio, so we detect ~3:4 (0.70–0.78) images once they
   load and tag ONLY those to fill their box (object-fit: cover) — a slight
   zoom that hides the wide side bars. All other images are left in full.

   Loaded ONLY when the "Zoom 3:4 images to fit" setting is on, and only by the
   sections whose rows it matches (recently viewed, ns-product-related, Dawn's
   related products, complementary products) — several of them can sit on one
   page, hence the guard. Swatch thumbnails are skipped (own fit).
   ============================================================ */
(function () {
  if (window.__nsPortraitFill) return;
  window.__nsPortraitFill = true;

  var LO = 0.7,
    HI = 0.78;
  var SEL = [
    '.ns-recently-viewed .card__media img',
    // "You may also like" / recommended cards load via AJAX (cached markup can
    // miss the server class), so tag them here too.
    'product-recommendations .card__media img',
    // The custom related section and any scrolling row. `product-recommendations`
    // alone missed both: ns-product-related.liquid renders into .ns-pdp-related
    // and the cards sit in a .ns-srow__track, so its sheepskins stayed on
    // `contain` and kept their side bars while the collection grid filled.
    '.ns-pdp-related .card__media img',
    '.ns-srow__track .card__media img',
  ].join(',');

  /* The rows those selectors live in. Each is an element that stays put while
     its cards are filled in: recently viewed renders into its own row, and
     <product-recommendations> replaces only its innerHTML. */
  var ROOTS = '.ns-recently-viewed, product-recommendations, .ns-srow__track';

  function tag(img) {
    if (!img || img.dataset.nsPf) return;
    if (img.closest && img.closest('.ns-card-swatch, .ns-card-swatches')) return;
    var w = img.naturalWidth,
      h = img.naturalHeight;
    if (!w || !h) return;
    img.dataset.nsPf = '1';
    var r = w / h;
    if (r >= LO && r <= HI) img.classList.add('ns-fill-portrait-img');
  }

  function check(img) {
    if (!img) return;
    if (img.complete && img.naturalWidth) tag(img);
    else
      img.addEventListener(
        'load',
        function () {
          tag(img);
        },
        { once: true }
      );
  }

  function scan(root) {
    try {
      (root || document).querySelectorAll(SEL).forEach(check);
    } catch (e) {}
  }

  // Recently-viewed + compare render asynchronously / on demand — re-scan on
  // DOM additions (debounced).
  var mo = null;
  if (window.MutationObserver) {
    var t;
    mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        scan(document);
      }, 60);
    });
  }

  /* Only the rows, not the whole document: a document-wide subtree observer
     woke on every header, drawer and grid mutation on every page. If none of
     the rows is on the page (markup this file does not know), the old
     document-wide watch is kept so nothing is missed. */
  function watch() {
    if (!mo) return;
    mo.disconnect();
    var roots = document.querySelectorAll(ROOTS);
    if (!roots.length) {
      mo.observe(document.documentElement, { childList: true, subtree: true });
      return;
    }
    for (var i = 0; i < roots.length; i++) mo.observe(roots[i], { childList: true, subtree: true });
  }

  function start() {
    scan(document);
    watch();
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);

  // Theme editor: a re-rendered section brings new row elements to watch.
  document.addEventListener('shopify:section:load', start);
})();
